import DependentReferenceInput from '@bit/vibedev.web.components.dependent-reference-input';

export default DependentReferenceInput;
